import {createCachedColumnSelector} from './createCachedColumnSelector';

// Hidden columns are excluded to mirror the rendered pinned partition
// (useOrderedVisibleColumns) — see usePinnedLeftColumns (T20-138452).
export const usePinnedRightColumns = createCachedColumnSelector(
  (col) => col.pinned === 'RIGHT' && col.hidden !== true
);
